import AdminLayout from "components/layouts/AdminLayout";
import SingleLoanViewModeratorForm from "components/tenders/singleLoan/SingleLoanViewModeratorForm";
import { useParams } from 'react-router';

function SingleLoanViewModeratorFormPage(props: any) {

    return (
        <AdminLayout>
            <SingleLoanViewModeratorForm {...{...props,...useParams()}} />
        </AdminLayout>
    );
}

export default SingleLoanViewModeratorFormPage;